import { BannerKey, BannerType } from 'features/banner/model/banner';
import useSendGTMAction from 'features/google-tag-manager/hooks/useSendGTMAction';
import { BannerActionClickedGtmAction } from 'features/google-tag-manager/model/actions/banner_action_clicked.gtm-action';
import { useDismissBanner } from 'hooks/dismiss-banner/useDismissBanner';
import { useTranslation } from 'react-i18next';
import { UpsellCardHeader } from './components/UpsellCardHeader';
import { UpsellCardSpotlight } from './components/UpsellCardSpotlight';
import { UpsellCardAction, UpsellCardDismiss, UpsellCardProps } from './models/upsell-card-props';

export const UpsellCard: React.FC<UpsellCardProps> = ({ position, dismiss, action, ...props }) => {
    const { t } = useTranslation();
    const sendGTMAction = useSendGTMAction();
    const { onDismiss, isDissmissed } = useDismissBanner(
        position !== undefined ? { key: BannerKey.UPSELL_CARD, position, index: 0, type: BannerType.CUSTOM } : undefined
    );

    if (position !== undefined && isDissmissed) {
        return null;
    }

    const resolvedDismiss: UpsellCardDismiss | undefined =
        dismiss ?? (position !== undefined ? { onClick: onDismiss, accessibilityLabel: t('BUTTON.CLOSE') } : undefined);

    const resolvedAction: UpsellCardAction | undefined =
        action?.gtmId && position !== undefined
            ? {
                  ...action,
                  onClick: (event) => {
                      sendGTMAction(
                          new BannerActionClickedGtmAction({
                              name: action.gtmId,
                              key: BannerKey.UPSELL_CARD,
                              position,
                          })
                      );
                      action.onClick?.(event);
                  },
              }
            : action;

    return props.variant === 'spotlight' ? (
        <UpsellCardSpotlight {...props} action={resolvedAction} dismiss={resolvedDismiss} />
    ) : (
        <UpsellCardHeader {...props} action={resolvedAction} dismiss={resolvedDismiss} />
    );
};
